<script lang="ts" setup>
import MainTitle from "~/components/ui/title/MainTitle.vue"
import type {IBrandInfo} from "~/shared/interfaces/brands"

const props = defineProps<{
  brandInfo: IBrandInfo
}>()

const formattedDescription = props.brandInfo.description
  .replace(/&lt;/g,'<')
  .replace(/&gt;/g, '>')
  .replace(/&amp;nbsp;/g, '&nbsp;')
  .replace(/&quot;/g, '"')
</script>

<template>
<section class="brand-info">
  <div class="container">
    <MainTitle  class="brand-info__title" :text="brandInfo.name"/>
    <div class="brand-info__desc">
      <div class="brand-info__desc-block">
        <div
          class="brand-info__desc-image"
          v-if="brandInfo.smallImage"
        >
          <img :src="brandInfo.smallImage" :alt="brandInfo.name">
        </div>
        <div
          class="brand-info__desc-items"
          v-if="brandInfo.country || brandInfo.site || brandInfo.documentation"
        >
          <div
            class="brand-info__desc-item"
            v-if="brandInfo.country"
          >
            <span>Страна производства</span>
            <span>{{brandInfo.country}}</span>
          </div>
          <div
            class="brand-info__desc-item"
            v-if="brandInfo.site"
          >
            <span>Официальный сайт</span>
            <a
              :href="brandInfo.site"
              target="_blank"
              rel="noopener noreferrer"
            >{{brandInfo.site}}</a>
          </div>
          <div
            class="brand-info__desc-item"
            v-if="brandInfo.documentation"
          >
            <span>Документация</span>
            <a
              :href="brandInfo.documentation"
              download
            >{{brandInfo.documentation}}</a>
          </div>
        </div>
      </div>
      <div class="brand-info__desc-block">
        <div
          class="brand-info__desc-sub-title"
          v-if="brandInfo.subTitle"
        >
          {{brandInfo.subTitle}}
        </div>
        <div
          class="brand-info__desc-txt"
          v-html="formattedDescription"
        ></div>
      </div>
    </div>
  </div>
</section>
</template>

<style lang="scss" scoped>
.brand-info {
  margin-top: 12px;

  .container {
    padding: 0 28px;
    @include md-breakpoint {
      padding: 0 20px;
    }
  }

  &__title {
    text-transform: uppercase;
  }

  &__desc {
    margin-top: 28px;
    display: flex;
    gap: 24px;
    @include sm-breakpoint {
      margin-top: 20px;
      flex-direction: column;
    }

    &-block {
      &:first-child {
        width: 306px;
        @include sm-breakpoint {
          width: 100%;
        }
      }

      &:last-child {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
    }

    &-image {
      width: 100%;
      border-radius: 16px;
      padding: 11px 12px;
      border: 1px solid $control-border_grey;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 282px;
        height: 121px;
        @include sm-breakpoint {
          width: 296px;
          height: 127px;
        }
      }
    }

    &-items {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 16px;
    }

    &-item {
      display: flex;
      flex-direction: column;
      gap: 4px;

      span {
        &:first-child {
          color: $content_secondary;
        }
      }

      a {
        color: $control-content_orange;

        &:hover:not(:active) {
          @include mf-breakpoint {
            color: $control-content_orange-hover;
          }
        }
      }
    }

    &-sub-title {
      @include font(18px, 24px, 600);
    }
  }
}
</style>
